module.exports = __webpack_public_path__ + "img/google-play.3379747f.png";